import { type ReactNode } from 'react';
import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { Button } from '.';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.backgroundColor};
  border: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
  box-shadow:
    0 4px 4px ${({ theme }) => rgba(theme.backgroundColor, 0.25)},
    0 0 54px ${({ theme }) => theme.backgroundColor},
    0 0 50px ${({ theme }) => rgba(theme.borderColor.DEFAULT, 0.25)};
  padding: 5px;
`;

interface MenuProps {
  children: ReactNode;
  className?: string;
}

export const Menu: React.ComponentType<MenuProps> = React.memo(
  ({ children, className }) => {
    return <Wrapper className={className}>{children}</Wrapper>;
  }
);

interface MenuItemProps {
  active?: boolean;
  onClick: (evt: React.FormEvent<HTMLDivElement>) => void;
  text: string | ReactNode;
}

export const MenuItem: React.ComponentType<MenuItemProps> = React.memo(
  ({ active = false, text, onClick }) => {
    return (
      <Button
        active={active}
        alignText="left"
        size="small"
        stylez="minimal"
        text={text}
        onClick={onClick}
      />
    );
  }
);
